export function isString(value: unknown): value is string {
  return typeof value === 'string' || value instanceof String;
}

export function isNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

export function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}

export function isFunction(value: unknown): value is (...args: unknown[]) => unknown {
  return typeof value === 'function';
}

export function isObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && value.constructor === Object;
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean';
}

export function isNull(value: unknown): value is null {
  return value === null;
}

export function isUndefined(value: unknown): value is undefined {
  return typeof value === 'undefined';
}

export function isRegExp(value: unknown): value is RegExp {
  return value !== null && typeof value === 'object' && value.constructor === RegExp;
}

export function isDate(value: unknown): value is Date {
  return value instanceof Date;
}

export function is<TClass>(x: unknown, c: new (...args: any[]) => TClass): x is TClass {
  return x instanceof c;
}

export function isEquals(lhs: unknown, rhs: unknown, lazyString = false): boolean {
  if (lhs === rhs || (lhs !== lhs && rhs !== rhs)) {
    return true;
  }

  if (lazyString) {
    const result = (lhs === '' && isUndefined(rhs)) || (rhs === '' && isUndefined(lhs));

    if (result) {
      return true;
    }
  }

  if (!lhs || !rhs) {
    return false;
  }

  if (isArray(lhs) && isArray(rhs)) {
    if (lhs.length !== rhs.length) {
      return false;
    }

    for (let i = 0; i < lhs.length; i++) {
      if (!isEquals(lhs[i], rhs[i], lazyString)) {
        return false;
      }
    }

    return true;
  } else if (isObject(lhs) && isObject(rhs)) {
    if (Object.keys(lhs).length !== Object.keys(rhs).length) {
      return false;
    }

    for (const key in lhs) {
      if (Object.prototype.hasOwnProperty.call(lhs, key)) {
        if (!isEquals((lhs as Record<string, unknown>)[key], (rhs as Record<string, unknown>)[key], lazyString)) {
          return false;
        }
      }
    }

    return true;
  }

  return false;
}
